<template>
    <div id="lt-yantr" class="calc-section yantr-tracking">
        <slot name="sub-heading"></slot>
        <h1 v-if="calculatorTitle">{{ calculatorTitle }}</h1>
        <h2 v-if="calculatorSubTitle">{{ calculatorSubTitle }}</h2>
        <div class="row">
            <div :class="filterWidth">
                <div :class="calcFilter">
                    <h4 v-if="filterTitle!==false" class="text-capitalize">
                        {{ filterTitle }}
                    </h4>
                    <slot name="filter"></slot>
                </div>
                <slot name="value-link"></slot>
            </div>
            <div :class="outputWidth">
                <slot name="output"></slot>
            </div>
        </div>
        <slot name="footer"></slot>
    </div>
</template>
<script>
    import CommonLayoutProps from '../mixin/common-layout-props';

    export default {
        mixins: [CommonLayoutProps],
    };
</script>
